

































































































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
@Component({
  components: {}
}) 
export default class smartFormInputType extends Vue {
  @Provide() tableData: any = [];
  @Provide() styleLData: any = [];
  @Provide() loading: boolean = false;
  @Provide() editInfo: any = {};
  @Provide() editInfoVisible: boolean = false;
  @Provide() options: any = [];
  @Provide() GetAppData: any = [];
  @Provide() scrollHeight = 500; //当前高度
  @Provide() rules = {
    styleName: [
      { required: true, message: "请输入关键词", trigger: "blur" },
      { min: 1, max: 20, message: "长度在 3 到 20 个字符", trigger: "blur" },
    ]
  };
  @Provide() formatList: any = [
    {
      value: "column",
      label: "标题在上输入框在下"
    },
    {
      value: "row",
      label: "标题在左输入框在右侧"
    },
    {
      value: "none",
      label: "不显示标题"
    }
  ];
  @Provide() formModel: any = {
    StyleId: 0,
    TenantID: getCookie("TenantID"),
    styleName: "",
    bgColor: "#ffffff",
    bgImg: "",
    topBottomPadding: 0,
    leftRightPadding: 0,
    fontSize: 0,
    fontColor: "#000000",
    formatType: "none",
    display: true
  };
  clearFormModel(){
    let _this = this;
    _this.formModel.StyleId = 0;
    _this.formModel.TenantID = getCookie("TenantID"),
    _this.formModel.styleName = "";
    _this.formModel.bgColor = "#FFF";
    _this.formModel.bgImg = "";
    _this.formModel.topBottomPadding = 0;
    _this.formModel.leftRightPadding = 0;
    _this.formModel.fontSize = 0;
    _this.formModel.fontColor = "#000000";
    _this.formModel.formatType = "none";
    _this.formModel.display = true;
  }
  @Provide() formModelVisible = false;
  created() {
    this.scrollHeight = document.body.scrollHeight - 430;
    let TenantID = getCookie("TenantID");
    if (!TenantID) {
      TenantID = "0";
    }
    this.GetAppData = {
      TenantID: TenantID
    };
    this.GetList();
    this.getStyleList();
  }
  @Provide() isBtnStatus:boolean = true;
  formHandleClick(tab:any, event:any){
    this.isBtnStatus = (tab.paneName=="1")?false:true;
  }
  // 检测表单名称是否重复
  async checkStyleName(){
    await this.getStyleList();
    this.styleLData.forEach((sitem:any ,sindex:any ,sarr:any) => {
      if(this.formModel.styleName == sitem.styleName){
        this.$message({
          message: '风格名称已存在！',
          type: 'warning'
        });
        this.formModel.styleName = "";
      }
    });
  }
  createFormModel(){
    this.formModelVisible=!this.formModelVisible; 
    // this.formModel.StyleId=0;
    this.clearFormModel();
  }
  //查询数据列表
  async GetList() {
    let params: any = {
      Input: [
        {
          Name: "TenantID",
          Value: getCookie("TenantID")
        }
      ]
    };
    var res: any = await httpApi.GetSySmartFormInputType(params);
    if (res.ErrorCode == 0) {
      this.tableData = res.output[0].value;
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  //加载风格列表数据
  async getStyleList() {
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.formModel
        }
      ]
    };
    var res: any = await httpApi.GetSySmartFormStyleAsync(params);
    if (res.ErrorCode == 0) {
      this.styleLData = res.output[0].value;
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  //保存自定义风格
  async SavaStyle() {
    var _this = this;
    (_this as any).$refs["formModel"].validate(async (valid: boolean) => {
      if (valid) {
        this.formModel.ActionName = "CREATE";
        let params: any = {
          Input: [
            {
              Name: "model",
              Value: this.formModel
            }
          ]
        };
        var res: any = await httpApi.SaveSySmartFormStyleAsync(params);
        if (res.ErrorCode == 0) {
          this.$message.success("保存成功！");
          this.formModelVisible = false;
          this.getStyleList();
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      } else {
        this.$message.error("请认真填写必填项！");
      }
    });
  }
  //修改风格
  async styleEdit(info: any) {
    this.formModelVisible = true;
    this.formModel = info;
  }
  //删除风格
  async styleDel(info: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      this.formModel = info;
      this.formModel.ActionName = "DELETE";
      let params: any = {
        Input: [
          {
            Name: "model",
            Value: this.formModel
          }
        ]
      };
      var res: any = await httpApi.SaveSySmartFormStyleAsync(params);
      if (res.ErrorCode == 0) {
        this.$message.success("删除成功！");
        this.formModelVisible = false;
        this.getStyleList();
      } else {
        this.$message.error("删除失败：" + res.ErrorMessage);
      }
    });
  }
  //上传背景图片
  async UploadImage(param: any) {
    //console.log(param);
    let reader = new FileReader();
    let typeValue = "SmartFormImage";
    // console.log(param);
    reader.readAsDataURL(param.file);
    //console.log(reader);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: typeValue
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SmartFormUploadVue(params);
        // console.log(res);
        if (res.ErrorCode == 0) {
          let valueStr = res.output[0].value;
          if (valueStr) {
            //console.log(valueStr);
            this.formModel.bgImg = valueStr;
          }
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //增加选项
  addOptions() {
    if (this.editInfo.apiName == "carousel") {
      this.options.push({ path: "", describe: "", url: "" });
    } else {
      this.options.push({ label: "", value: "" });
    }
    this.editInfo.options = this.options;
  }
  //删除选项
  delOptions(index: number) {
    this.options.splice(index, 1);
    this.editInfo.options = this.options;
  }
  //弹出编辑框
  handleEdit(info: any) {
    this.editInfoVisible = true;
    this.editInfo = info;
    this.options = [];
    if (this.editInfo.apiName == "carousel") {
      this.options.push({ path: "", describe: "", url: "" });
    } else {
      this.options.push({ label: "", value: "" });
    }
    if (!this.editInfo.options) {
      this.editInfo.options = this.options;
    } else {
      this.editInfo.options = JSON.parse(this.editInfo.options);
      this.options = this.editInfo.options;
    }
  }
  //保存数据
  async SavatData() {
    this.editInfo.options = JSON.stringify(this.editInfo.options);
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.editInfo //消息模板类型
        }
      ]
    };
    var res: any = await httpApi.SaveSySmartFormInputType(params);
    if (res.ErrorCode == 0) {
      this.$message.success("保存成功！");
      this.editInfo.options = JSON.parse(this.editInfo.options);
      this.editInfoVisible = false;
    } else {
      this.options = JSON.parse(this.editInfo.options);
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
}
